// extracted by mini-css-extract-plugin
module.exports = {"JobBoardContainer":"JobBoardContainer_JobBoardContainer__3eJph","FiltersLegendWrapper":"JobBoardContainer_FiltersLegendWrapper__3Rt_9"};